// src/components/ElectricalContactBox.js
"use client"

import React from "react"

const ElectricalContactBox = ({ header, onChange, onSave, saving }) => {
  const handleField = (field) => (e) => {
    onChange({ [field]: e.target.value })
  }

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <h2 className="mb-3 text-sm font-semibold text-slate-900">
        Project & Contact Info
      </h2>

      <div className="space-y-3">
        <div className="space-y-1">
          <label
            htmlFor="project-address"
            className="block text-xs font-medium text-slate-700"
          >
            Project Address <span className="text-red-500">*</span>
          </label>
          <input
            id="project-address"
            type="text"
            value={header.project_address || ""}
            onChange={handleField("project_address")}
            placeholder=""
            className="w-full rounded-md border border-red-300 px-3 py-2 text-xs text-slate-900 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </div>
        <div className="space-y-2">
          <label
            htmlFor="project-description"
            className="block text-xs font-medium text-slate-700"
          >
            Project Description
          </label>
          <input
            id="project-description"
            type="text"
            value={header.project_description || ""}
            onChange={handleField("project_description")}
            placeholder=""
            className="w-full rounded-md border border-slate-300 px-3 py-2 text-xs text-slate-900 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </div>

        <div className="space-y-1">
          <label
            htmlFor="contact-name"
            className="block text-xs font-medium text-slate-700"
          >
            Contact Name <span className="text-red-500">*</span>
          </label>
          <input
            id="contact-name"
            type="text"
            value={header.contact_name || ""}
            onChange={handleField("contact_name")}
            placeholder=""
            className="w-full rounded-md border border-red-300 px-3 py-2 text-xs text-slate-900 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </div>

        <div className="grid gap-3 sm:grid-cols-2">
          <div className="space-y-1">
            <label
              htmlFor="contact-email"
              className="block text-xs font-medium text-slate-700"
            >
              Contact Email
            </label>
            <input
              id="contact-email"
              type="email"
              value={header.contact_email || ""}
              onChange={handleField("contact_email")}
              placeholder="email@example.com"
              className="w-full rounded-md border border-slate-300 px-3 py-2 text-xs text-slate-900 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>
          <div className="space-y-1">
            <label
              htmlFor="contact-phone"
              className="block text-xs font-medium text-slate-700"
            >
              Contact Phone
            </label>
            <input
              id="contact-phone"
              type="tel"
              value={header.contact_phone || ""}
              onChange={handleField("contact_phone")}
              placeholder="10-digit phone"
              className="w-full rounded-md border border-slate-300 px-3 py-2 text-xs text-slate-900 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>
        </div>

        <div className="space-y-1">
          <label
            htmlFor="project-notes"
            className="block text-xs font-medium text-slate-700"
          >
            Project Notes
          </label>
          <textarea
            id="project-notes"
            rows={3}
            value={header.project_notes || ""}
            onChange={handleField("project_notes")}
            placeholder="Scope notes, exclusions, special conditions..."
            className="w-full rounded-md border border-slate-300 px-3 py-2 text-xs text-slate-900 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </div>

        <button
          type="button"
          onClick={onSave}
          disabled={saving}
          className="mt-2 inline-flex w-full items-center justify-center rounded-md bg-blue-600 px-3 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {saving ? "Saving…" : "💾 Save Project Info"}
        </button>
      </div>
    </div>
  )
}

export default ElectricalContactBox
